const isProductionAppEnv = (): boolean =>
  process.env.APP_ENV === 'prod' || process.env.NEXT_PUBLIC_APP_ENV === 'prod'

export const isDevToolsEnabled = (): boolean => !isProductionAppEnv()

export const resolveAppEnvironmentLabel = (): string => {
  if (isProductionAppEnv()) {
    return 'Production'
  }

  return process.env.NEXT_PUBLIC_APP_ENV === 'staging' ? 'Staging' : 'Development'
}
